module.exports = [{
      plugin: require('../../gatsby-plugin-gtm/gatsby-browser.js'),
      options: {"plugins":[],"gtmId":"GTM-P9FVGMK"},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-react-helmet-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://toggl.com"},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx"],"defaultLayouts":{},"gatsbyRemarkPlugins":[],"lessBabel":false,"remarkPlugins":[],"rehypePlugins":[],"mediaTypes":["text/markdown","text/x-markdown"]},
    },{
      plugin: require('../../toggl/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
